export default __webpack_public_path__ + "5bba8af.png";